import { useMemo } from 'react';
import { ColDef, FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, IHeaderParams, RowClassParams } from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { IAdminRelativePerformance } from '@nkr/models/index';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { GridWrapper } from './styles';

interface IProps {
    data: IAdminRelativePerformance[],
    onGridReady: (e: GridReadyEvent) => void,
}

const Grid = (props: IProps) => {
    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    }

    const columns: ColDef[] = [
        {
            headerName: 'Date',
            field: 'date',
            hide: true
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Rank</SortableHeaderComponent>,
            headerName: 'Rank',
            field: 'rank',
            flex: 1,
            headerComponentParams: {
                displayName: 'Rank'
            },
            //cellStyle: {textAlign: 'center'}
            width: 50,
        },

        {
            headerName: 'CenterId',
            field: 'centerId',
            hide: true
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center</SortableHeaderComponent>,
            headerName: 'Center',
            field: 'centerAlias',
            headerComponentParams: {
                displayName: 'Center'
            },
            //cellStyle: {textAlign: 'center'}
            width: 100,
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Metric</SortableHeaderComponent>,
            headerName: 'Metric',
            field: 'metric',
            flex: 1,
            headerComponentParams: {
                displayName: 'Metric'
            },
            //cellStyle: {textAlign: 'center'}
            width: 250,
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Value</SortableHeaderComponent>,
            headerName: 'Value',
            field: 'value',
            flex: 1,
            headerComponentParams: {
                displayName: 'Value'
            },
            cellStyle: {textAlign: 'center'},
            width: 130,
            sortable: false,
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Rank in Network</SortableHeaderComponent>,
            headerName: 'Rank in Network',
            field: 'rankInNetwork',
            flex: 1,
            headerComponentParams: {
                displayName: 'Rank in Network'
            },
            cellStyle: {textAlign: 'center'},
            width: 130,
            comparator: (valA, valB) => {
                const sentinelRanks: { [key: string]: number } = { 'NV': -2, 'N/A': -1 };
                const toRankNumber = (val: string) => {
                    if (val in sentinelRanks) return sentinelRanks[val];
                    const parsed = Number(val);
                    return Number.isNaN(parsed) ? 0 : parsed;
                };
                return toRankNumber(valA) - toRankNumber(valB);
            }
            
        },
    ]

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <GridWrapper>
            <AgGridReact
                defaultColDef={{
                    headerClass: 'list-header',
                    cellClass: 'list-cell',
                    sortable: true,
                    resizable: true
                }}
                gridOptions={
                    {
                        defaultCsvExportParams: {
                            allColumns: true
                        }
                    }
                }
                columnDefs={columnDefs}
                rowData={rowData}
                headerHeight={32}
                rowHeight={28}
                suppressRowClickSelection={false}
                suppressCellSelection={true}
                suppressContextMenu={true}
                getRowStyle={(params: RowClassParams) => {
                    return {border: '1px solid rgba(0, 0, 0, 0.2)', fontFamily: 'Tahoma', fontSize: '16px'}
                }}
                noRowsOverlayComponentFramework={() => <div></div>}
                onGridReady={props.onGridReady}
                onFirstDataRendered={onFirstDataRendered}
            />
        </GridWrapper>
    );
} 

export default Grid;